module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-header"
  }, [_c('el-tabs', {
    staticClass: "tab-header-list",
    on: {
      "tab-click": _vm.handleTabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(tabItem, tebIndex) {
    return _c('el-tab-pane', {
      key: tebIndex,
      attrs: {
        "name": tabItem.name
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("\n                " + _vm._s(tabItem.special ? (_vm.isSelf ? '关注我的人' : '关注他的人') : (_vm.isSelf ? '我' : '他') + tabItem.label) + "\n                "), (_vm.isCount) ? _c('span', {
      staticClass: "label-num"
    }, [_vm._v(_vm._s(tabItem.count || 0))]) : _vm._e()])])
  }), 1), _vm._v(" "), (_vm.isSort) ? _c('ul', {
    staticClass: "sort-list"
  }, _vm._l((_vm.sortList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': _vm.sortType === item.sort
      },
      on: {
        "click": function($event) {
          return _vm.onSwitchSort(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.value) + "\n        ")])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-64018a9b!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/tabHeader.vue
// module id = g4sf
// module chunks = 16